module.exports = __webpack_public_path__ + "agency-academy.1956377b491942eff8a3.png";